import { Component, DoCheck, Input, IterableDiffer, IterableDiffers, OnInit } from '@angular/core';
import { AbstractControl, ControlContainer, FormArray, FormGroup } from '@angular/forms';
import { NextcloudFile } from 'src/app/classes';
import { FileService } from '../../../services/file.service';

@Component({
  selector: 'app-attachement-preview',
  templateUrl: './attachement-preview.component.html',
  styleUrls: ['./attachement-preview.component.css']
})
export class AttachementPreviewComponent implements DoCheck, OnInit {

  @Input() limit: number = 3;

  icon: string;

  formGroup: FormGroup;
  attachements: attachementWrapper[] = [];

  iterableDiffer: IterableDiffer<AbstractControl>;

  constructor(
    private _controlContainer: ControlContainer,
    private _fileService: FileService,
    private _iterableDiffers: IterableDiffers
  ) { }

  ngDoCheck() {
    if(this.iterableDiffer.diff(this.attachementsControl.controls)) this.setattachements();
  }

  ngOnInit(): void {
    this.formGroup = <FormGroup>this._controlContainer.control;

    this.iterableDiffer = this
      ._iterableDiffers
      .find(this.attachementsControl.controls)
      .create((index: number, item: AbstractControl) => {
        return (item.value as NextcloudFile).uuid;
      });
  }

  setattachements() {
    this.attachements = [];
    for (let attachement of this.attachementsControl.controls) {
      this.attachements.push({
        'icon': FileService.getFileType((attachement.value as NextcloudFile).type),
        'file': attachement.value as NextcloudFile,
        'name': FileService.getFileName((attachement.value as NextcloudFile).href)
      });
    }
  }

  // controls
  get attachementsControl(): FormArray {
    return this.formGroup.controls['attachements'] as FormArray;
  }

}

export class attachementWrapper {
  icon: string;
  file: NextcloudFile;
  name: string;
}
